module.exports = __webpack_public_path__ + "static/img/youzan.cbb0968f.png";